import * as Yup from "yup";


export const forgotPasswordValidationSchema = Yup.object().shape({
    email: Yup.string().max(30, "Maximum 30 characters required").email('Enter valid email address').required("Email ID is required"),
  });